<template>
    <div class="w-full h-[calc(100vh-3.5rem)] fixed">
        <div class="h-14 items-center w-full flex border-b border-gray-200">
            <div class="flex items-center space-x-2 px-2">
            </div>
            <div v-if="isLoading" class="flex items-center space-x-2 px-4">
                <svg aria-hidden="true" class="mx-1 w-6 h-6 text-gray-200 animate-spin dark:text-gray-600"
                    viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="#d3d3d3"/>
                        <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="#2E9CCA"/>
                </svg>
                <div class="text-gray-800 whitespace-nowrap text-sm">
                    Please wait: Retrieving company locations.
                </div>
            </div>
            <!-- <div class="place-autocomplete-card bg-white px-4 py-2 h-fit flex flex-col w-fit shadow-md space-y-2 items-start justify-between rounded-sm mt-2.5" id="place-autocomplete-card">
                <div class="px-1 flex items-end space-x-2 h-full">
                    <div
                        class="rounded-sm hover:bg-gray-300 p-3 hover:cursor-pointer"
                        @click="toggleFilters"
                        ref="filterBoundary"
                    >
                        <FilterSVG />
                    </div>
                    <div class="flex flex-col place-autocomplete-container w-[300px] justify-between" id="place-autocomplete-container">
                        <div class="text-gray-800 tracking-wide text-sm font-medium whitespace-nowrap pb-1.5" :style="addressLabelStyle">
                            Search Address:
                        </div>
                    </div>
                    <div class="flex flex-col justify-between">
                        <div class="text-gray-800 tracking-wide text-sm font-medium whitespace-nowrap pb-1.5">
                            Latitude:
                        </div>
                        <input type="number" id="latitude" min="-90" max="90" step="0.0000000000000001" v-model="pointOfInterestFilters.latitude" class="border p-2.5 w-full h-full text-sm rounded border-black" />
                    </div>
                    <div class="flex flex-col justify-between">
                        <div class="text-gray-800 tracking-wide text-sm font-medium whitespace-nowrap pb-1.5">
                            Longitude:
                        </div>
                        <input type="number" id="longitude" min="-180" max="180" step="0.0000000000000001" v-model="pointOfInterestFilters.longitude" class="border p-2.5 w-full h-full text-sm rounded border-black" />
                    </div>
                    <div class="flex flex-col justify-between h-full">
                        <div class="text-gray-800 tracking-wide text-sm font-medium whitespace-nowrap pb-1.5">
                            Search Radius:
                        </div>
                        <select class="border p-2 w-full h-full text-sm rounded border-black" v-model="pointOfInterestFilters.searchRadius" name="" id="">
                            <option v-for="searchRadiusOption in searchRadiusOptions" :key="searchRadiusOption.value" :value="searchRadiusOption.value">
                                {{ searchRadiusOption.label }}
                            </option>
                        </select>
                    </div>
                    <div class="h-full w-fit">
                        <button class="text-sm bg-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 text-white whitespace-nowrap tracking-wider font-medium px-4 py-2 rounded" @click="searchCompanyLocations">Search</button>
                    </div>
                </div>
                <div v-show="visibleFilters" class="w-full pb-2 border-t border-gray-300">
                    <FilterForm
                        :filters="filters"
                        @change-filters="changeFilters"
                    />
                </div>
            </div> -->
        </div>
        <base-modal :is-form-visible="visibleCompanyForm" @close="closeCompanyForm">
          <template #header>
            <h2 class="text-lg">{{ detailCompany.company_name }} {{ detailCompany.id }}</h2>
          </template>
          <template #body>
            <EditCompany
                :company="detailCompany"
                :campaigns="campaigns"
                @close="closeCompanyForm"
                @refetch-companies="loadCompanyLocations"
            />
          </template>
        </base-modal>
        <div v-if="viewType=='geoSearch'" class="flex w-full h-full fixed">
            <div class="w-3/4 h-full">
                <GeoMap
                    :companyLocations="companyLocations" 
                    :mapOptions="mapOptions"
                    :reloadMap="reloadMap"
                    :filters="companyLocationFilters"
                    :selected-company-location="selectedCompanyLocation"
                    :new-company-row-selected="newCompanyRowSelected"
                    :new-cluster-row-selected="newClusterRowSelected"
                    @map-init-complete="setLoadingFalse"
                    @change-poi-search="changeFiltersByPointOfInterest"
                    @fetch-company-locations="loadCompanyLocations"
                    @set-clusters="setClusters"
                    @select-location-pin="selectCompanyLocationRowFromPin"
                    @closed-info-window="clearSelectedCompanyLocationRow"
                />
            </div>
            <div class="w-1/4 h-full border-l border-gray-200">
                <CompanyLocationResults
                    :company-locations="companyLocations"
                    :selected-company-location="selectedCompanyLocation"
                    :filters="fetchFilter"
                    :clusters="clusters"
                    :num-clusters="numClusters"
                    :bulk-operations="companyLocationBulkOperations"
                    @open-company-modal="getCompanyAndOpenModal"
                    @select-company-location="selectCompanyLocationPinFromRow"
                    @select-company-cluster="selectCompanyClusterFromRow"
                />
            </div>
        </div>
        <div v-else-if="viewType=='densityMap'" class="flex w-full h-full fixed">
            Density Map
        </div>

        <!-- <div class="w-full flex justify-between items-center px-2">
            <div class="h-10 flex whitespace-nowrap items-center text-sm text-gray-800 tracking-wide font-medium">Company Geo Locations: {{ numLocations }} Results</div>
            <div class="w-full px-2">
                <FilterForm
                    :filters="companyLocationFilters"
                    @change-filters="changeFilters"
                />
            </div>
            <div>
                <BaseButton class="text-xs" @click="loadCompanyLocations(fetchFilter)">Search</BaseButton>
            </div>
        </div>
        <GeoMap 
            v-if="companyLocations.length > 0"
            :companyLocations="companyLocations" 
            :mapOptions="mapOptions"
            @map-init-complete="setLoadingFalse"
        />
        <div v-else class="w-full h-[calc(100vh-8.5rem)] bg-gray-100 flex justify-center items-center text-gray-800 tracking-wider font-medium text-sm">
            <div v-if="!isLoading">
                No Locations Found
            </div>
        </div> -->
    </div>
</template>

<script setup>
import { ref, reactive, defineProps, defineEmits, watch, computed, effect } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';
import GeoMap from './GeoMap.vue';
import CompanyLocationResults from './CompanyLocationResults.vue';
import { getActiveCampaigns } from '@/services/Campaign';
import { getCompanyByID } from '@/services/Company';
import FilterSVG from '../svg-components/FilterSVG.vue';
import FilterForm from '../base-components/FilterForm.vue';
import { getCompanyLocations } from '@/services/CompanyLocation';
import { parseDMSCoordinates } from '@/composables/geoLocationTools';
import { getClients } from '@/services/Client';
import { getCampaigns } from '@/services/Campaign';
import { getTiers } from '@/services/Tiers';
import { getCollectionTags } from '@/services/CollectionTag';
import EditCompany from '../EditCompany.vue';

const store = useStore()
const $toast = useToast()

const isLoading = ref(false)
const mapOptions = reactive({
    zoom: 5,
    maxZoom: 17,
    minZoom: 3,
    center: { lat: 40.6331, lng: -89.3985 },
    mapId: "99bc138cb59717d1",
})

const viewType = ref('geoSearch')

const tabs = reactive({
    geoSearch: {
        label: 'Geo Search', isSelected: true
    },
    densityMap: {
        label: 'Density Map', isSelected: false
    },
})


// const mapZoom = ref(12)
const clusters = ref(null)
const numClusters = ref(0)
const campaigns = ref([])

const companyLocations = ref([])

const visibleCompanyForm = ref(false)
const detailCompany = ref(null)

const selectedCompanyLocation = ref(null)
const newCompanyRowSelected = ref(false)
const newClusterRowSelected = ref(false)

const numLocations = computed(() => {
    return companyLocations.value.length
})


const iLBoundaries = ref(null)

const companyLocationFilters = reactive({
    region: {
        name: "region",
        label: "Region",
        value: null,
        defaultValue: null,
        options: [
            {
                value: null, 
                label: "------------",
                mapOptions: {
                    zoom: 5,
                    maxZoom: 17,
                    minZoom: 3,
                    center: { lat: 40.6331, lng: -89.3985 },
                    mapId: "99bc138cb59717d1",
                }
            },
            {
                value: 'us_northeast', 
                label: "US Northeast", 
                mapOptions: {
                    zoom: 5,
                    maxZoom: 6,
                    minZoom: 3,
                    center: { lat: 41.52866854766153, lng: -74.42072602101543 },
                    mapId: "99bc138cb59717d1",
                }
            },
            {
                value: 'us_midwest', 
                label: "US Midwest", 
                mapOptions: {
                    zoom: 5,
                    maxZoom: 6,
                    minZoom: 3,
                    center: { lat: 44.079045007363156, lng: -93.7920423533656 },
                    mapId: "99bc138cb59717d1",
                }
            },
            {
                value: 'us_west', 
                label: "US West", 
                mapOptions: {
                    zoom: 3,
                    maxZoom: 6,
                    minZoom: 3,
                    center: { lat: 39.56628703111894, lng: -133.62741593864686 },
                    mapId: "99bc138cb59717d1",  
                }
            },
            {
                value: 'us_south', 
                label: "US South",
                mapOptions: {
                    zoom: 4,
                    maxZoom: 6,
                    minZoom: 3,
                    center: { lat: 36.764467042019916, lng: -97.99829697254111 },
                    mapId: "99bc138cb59717d1",
                }
            },
            // {value: 'us_territories', label: "Other US Territories"},
            // {value: 'americas_non_us', label: "Americas (Non-US)"},
            // {value: 'europe', label: "Europe"},
            // {value: 'apac', label: "APAC"},
            // {value: 'africa_middle_east', label: "Africa / Middle East"},
        ],
        widget: 'list-box',
        multiSelect: false,
        visible: true,
    },
    country: {
        name: "country",
        label: "Country",
        value: null,
        defaultValue: null,
        options: [
            {value: null, label: "------------"}, 
        ],
        widget: 'list-box',
        multiSelect: false,
        visible: false,
    },
    state: {
        name: "state",
        label: "State",
        value: [],
        defaultValue: [],
        options: [
            {value: null, label: "------------"}, 
        ],
        widget: 'list-box',
        multiSelect: true,
        visible: false,
    },
    city: {
        name: "city",
        label: "City",
        value: [],
        defaultValue: [],
        options: [
            {value: null, label: "------------"}, 
        ],
        widget: 'list-box',
        multiSelect: true,
        visible: false,
    },
    minLat: {
        name: "min_lat",
        label: "Minimum Latitude",
        value: -90,
        defaultValue: -90,
        widget: 'input',
        type: 'number',
        multiSelect: false,
        visible: false,
    },
    maxLat: {
        name: "max_lat",
        label: "Maximum Latitude",
        value: 90,
        defaultValue: 90,
        widget: 'input',
        type: 'number',
        multiSelect: false,
        visible: false,
    },
    minLong: {
        name: "min_long",
        label: "Minimum Longitude",
        value: -180,
        defaultValue: -180,
        widget: 'input',
        type: 'number',
        multiSelect: false,
        visible: false,
    },
    maxLong: {
        name: "max_long",
        label: "Maximum Longitude",
        value: 180,
        defaultValue: 180,
        widget: 'input',
        type: 'number',
        multiSelect: false,
        visible: false,
    },
    // activeCampaign: {

    // },
    client: {
        name: "client",
        label: "Client",
        value: [],
        defaultValue: [],
        options: [
            {value: null, label: "------------"}, 
        ],
        widget: 'list-box',
        multiSelect: true,
        visible: true,
    },
    campaign: {
        name: "campaign",
        label: "Campaign",
        value: [],
        defaultValue: [],
        options: [
            {value: null, label: "------------"}, 
        ],
        widget: 'list-box',
        multiSelect: true,
        visible: true,
    },
    tier: {
        name: "tier",
        label: "Tier",
        value: [],
        defaultValue: [],
        options: [
            {value: null, label: "------------"}, 
        ],
        widget: 'list-box',
        multiSelect: true,
        visible: true,
    },
    collection: {
        name: "collection",
        label: "Collection",
        value: [],
        defaultValue: [],
        options: [
            {value: null, label: "------------"}, 
        ],
        widget: 'list-box',
        multiSelect: true,
        visible: true,
    },
    revenueGroup: {
        name: "revenue_group",
        label: "Revenue",
        value: null,
        defaultValue: null,
        options: [
            {value: null, label: "------------"},
            {value: '<5', label: "<5"},
            {value: '5-10', label: "5-10"},
            {value:'10-50', label: "10-50"},
            {value: '50-100', label: "50-100"},
            {value: '100+', label: "100+"},
            {value: 'unknown', label: "Unknown"},
        ],
        widget: 'list-box',
        multiSelect: false,
        visible: true,
    },

})

const companyLocationBulkOperations = reactive({
    assignSelectedResultsToCollection: {
        label: 'Assign Selected Results to Collection',
        modelPath: 'companies',
        endpoint: 'bulk_assign_collection_tag',
        message: '',
        requireSelectedResults: true,
        inputs: {
            collectionTag: {
                label: "Choose Collection Tag:",
                value: [],
                defaultValue: [],
                options: [
                    {value: "clear", label: "------------"}
                ],
                widget: 'datalist',
            }
        }
    },
})

const fetchFilter = computed(() => {
    let query = new URLSearchParams({});
    for(const filter in companyLocationFilters) {
        // console.log('filter')
        // console.log(filter)
        if(companyLocationFilters[filter].multiSelect) {
            if(companyLocationFilters[filter].value.length > 0) {
                companyLocationFilters[filter].value.forEach(filterValue => {
                    query.append(companyLocationFilters[filter].name, filterValue)
                })
            }
        } else {
            if(companyLocationFilters[filter].value) {
                query.append(companyLocationFilters[filter].name, companyLocationFilters[filter].value)
            }
        }
    }
    let url;
    let queriesCount = 0;
    for (let value of query.values()) {
        queriesCount = queriesCount + 1;
    }
    if (queriesCount > 0) {
        url = "?" + query.toString();
    } else {
        url = "?";
    }
    return url
})

const centerLat = ref(36.764467042019916)
const centerLong = ref(-97.99829697254111)
const reloadMap = ref(false)

function clearAllTabs() {
    for(const tab of Object.values(tabs)) {
        tab.isSelected = false
    }
}
function setResultsView(viewTypeValue) {
    viewType.value = viewTypeValue
}

function setPage(tabKey) {
    clearAllTabs()
    tabs[tabKey].isSelected = true;
    setResultsView(tabKey)
}

watch(() => companyLocationFilters.country.value, () => {
    if(companyLocationFilters.country.value == 'USA') {
        companyLocationFilters.state.visible = true
        companyLocationFilters.city.visible = true
    } else {
        companyLocationFilters.state.visible = false
        companyLocationFilters.city.visible = false
    }
})

watch(() => companyLocationFilters.region.value, () => {
    console.log('companyLocationFilters - region watcher')
    setMapOptionsByRegion(companyLocationFilters.region.value)
    if(companyLocationFilters.region.value) {
        resetLatLongRange()
        let filterRegion = companyLocationFilters.region.options.find((region) => region.value == companyLocationFilters.region.value)
        console.log(filterRegion)
        centerLat.value = parseFloat(filterRegion.mapOptions.center.lat)
        centerLong.value = parseFloat(filterRegion.mapOptions.center.lng)
    }
})

function changeFiltersByPointOfInterest(pointOfInterestFilters) {
    console.log('changeFiltersByPointOfInterest')
    updateCoordMinMaxByPOI(pointOfInterestFilters.latitude, pointOfInterestFilters.longitude, pointOfInterestFilters.searchRadius)
}

function updateCoordMinMaxByPOI(latitude, longitude, searchRadius) {
    if(latitude) {
        centerLat.value = latitude
        companyLocationFilters.minLat.value = latitude - searchRadius
        companyLocationFilters.maxLat.value = latitude + searchRadius
    } else {
        resetLatRange()
    }
    if(longitude) {
        centerLong.value = longitude
        companyLocationFilters.minLong.value = longitude - searchRadius
        companyLocationFilters.maxLong.value = longitude + searchRadius
    } else {
        resetLongRange()
    }
    console.log(fetchFilter.value)
}

function setLoadingFalse() {
    isLoading.value = false
}

function clearSelectedCompanyLocationRow() {
    console.log('clearSelectedCompanyLocationRow')
    selectedCompanyLocation.value = null

}

function selectCompanyLocationRowFromPin(companyLocation) {
    console.log('selectCompanyLocationRowFromPin', companyLocation)
    selectedCompanyLocation.value = companyLocation
    let companyRow = document.getElementById(companyLocation.id)
    companyRow.scrollIntoView()
    companyRow.scrollIntoView(false);
    companyRow.scrollIntoView({ block: "start" });
    companyRow.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });

}

function selectCompanyClusterFromRow(companyCluster) {
    setMapCenter(parseFloat(companyCluster._position.lat()), parseFloat(companyCluster._position.lng()))
    mapOptions.zoom = 9
    newClusterRowSelected.value = !newClusterRowSelected.value
}

function selectCompanyLocationPinFromRow(companyLocation) {
    console.log('selectCompanyLocation', companyLocation)
    selectCompanyLocationRowFromPin(companyLocation)
    console.log(companyLocation.location.lat, companyLocation.location.long)
    setMapCenter(parseFloat(companyLocation.location.lat), parseFloat(companyLocation.location.long))
    mapOptions.zoom = 11
    newCompanyRowSelected.value = !newCompanyRowSelected.value
    // mapOptions.value = {
    //     zoom: 10,
    //     maxZoom: 17,
    //     minZoom: 3,
    //     center: {lat: parseFloat(companyLocation.location.lat), lng: parseFloat(companyLocation.location.long) },
    //     mapId: "99bc138cb59717d1",
    // }
   
}

function resetLatLongRange() {
    resetLatRange()
    resetLongRange()
}

function resetLatRange() {
    companyLocationFilters.minLat.value = -90
    companyLocationFilters.maxLat.value = 90
}

function resetLongRange() {
    companyLocationFilters.minLong.value = -180
    companyLocationFilters.maxLong.value = 180
}


function clearCompanyLocations() {
    companyLocations.value = []
}

function setCenterAndReloadMap(latitude, longitude) {
    setMapCenter(latitude, longitude)
    reloadMap.value = !reloadMap.value
}

function setMapCenter(latitude, longitude) {
    mapOptions.center = {
        lat: latitude,
        lng: longitude
    }
}

function setMaxZoom(numberLocations) {
    console.log('setMaxZoom', numberLocations)
    let maxZoom = 19
    let zoom = 4
    if(numberLocations >= 20000) {
        maxZoom = 4
        zoom = 3
    } else if(numberLocations >= 10000) {
        maxZoom = 5
        zoom = 4
    } else if (numberLocations >= 5000) {
        maxZoom = 6
        zoom = 4
    } else if (numberLocations >= 2000) {
        maxZoom = 15
        zoom = 4
    } else if (numberLocations >= 1000) {
        maxZoom = 17
        zoom = 4
    }
    mapOptions.maxZoom = maxZoom
    mapOptions.zoom = zoom
}

function setClusters(clustersValue){
    clusters.value = clustersValue
    if(clustersValue) {
        numClusters.value = clustersValue.length
    }

}

function closeCompanyForm() {
    visibleCompanyForm.value = false
    detailCompany.value = null
}

function setMapOptionsByRegion(regionValue) {
    let newMapOptions = companyLocationFilters.region.options.find((regionOption) => regionOption.value == regionValue).mapOptions
    mapOptions.zoom = newMapOptions.zoom
    mapOptions.maxZoom = newMapOptions.maxZoom
    mapOptions.minZoom = newMapOptions.minZoom
    mapOptions.center = newMapOptions.center
    // console.log('regionValue', regionValue)
    // console.log('mapOptions')
    // console.log(mapOptions.value)
}

function getILCoordinates(){
    console.log('getILCoordinates')
    let swCoords = `36°58'0" N 87°30'0" W`
    const swCoordObject = parseDMSCoordinates(swCoords)
    let neCoords = `42°30'0" N 91°30'0" W`
    const neCoordObject = parseDMSCoordinates(neCoords)
    iLBoundaries.value = {
        sW: {lat: swCoordObject.lat, long: swCoordObject.long},
        nE: {lat: neCoordObject.lat, long: neCoordObject.long},
    }
}

async function setClientOptions() {
    const token = store.getters['auth/showToken']
    const result = await getClients({token: token})
    companyLocationFilters.client.options = [{value: "clear", label: "------------"}, ...result.data.results.map((client) => {
        return {value: client.id, label: client.client_name}
    })]
}

async function setCampaignOptions() {
    const token = store.getters['auth/showToken']
    const result = await getActiveCampaigns(token)
    companyLocationFilters.campaign.options = [{value: "clear", label: "------------"}, {value: "null", label: "Unassigned"}, ...result.map((campaign) => {
        return {value: campaign.id, label: campaign.campaign_name}
    })]
    campaigns.value = result
}

async function setTierOptions() {
        const token = store.getters['auth/showToken']
        const result = await getTiers(token)
        companyLocationFilters.tier.options = [{value: "clear", label: "------------"}, ...result.map((tier) => {
          return {value: tier.id, label: tier.tier_name}
        })]
      }

async function setCollectionTagOptions() {
    const token = store.getters['auth/showToken']
    const result = await getCollectionTags(token)
    companyLocationFilters.collection.options = [{value: "clear", label: "------------"}, ...result.map((collectionTag) => {
        return {value: collectionTag.id, label: collectionTag.collection_tag_name }
    })]
    companyLocationBulkOperations.assignSelectedResultsToCollection.inputs.collectionTag.options = [{value: "clear", label: "------------"}, ...result.map((collectionTag) => {
        return {value: collectionTag.collection_tag_name, label: collectionTag.collection_tag_name }
    })]
}

async function loadCompanyLocations() {
    console.log('loadCompanyLocations')
    isLoading.value = true;
    const token = store.state.auth.token
    // clearCompanyLocations()
    console.log(fetchFilter.value)
    const response = await getCompanyLocations(token, fetchFilter.value)
    isLoading.value = false;
    if(response.status == 200) {
        companyLocations.value = response.data
        console.log(centerLat.value, centerLong.value)
        if(centerLat.value && centerLong.value) {
            console.log('centerLat and Long - reloading map')
            setMaxZoom(companyLocations.value.length)
            setCenterAndReloadMap(centerLat.value, centerLong.value)
        }
    } else {
        $toast.open({
            message: `Error retrieving company locations.`,
            type: 'error',
            duration: 10000
        })
    }
}

async function getCompanyAndOpenModal(companyId) {
    console.log('getCompanyAndOpenModal', companyId)
    isLoading.value = true
    const token = store.state.auth.token
    const result = await getCompanyByID({token: token, companyId: companyId})
    console.log(result)
    if(result.response.status == 200) {
        detailCompany.value = result.response.data
        visibleCompanyForm.value = true
    } else {
        $toast.open({
            message: `Error retrieving company.`,
            type: 'error',
            duration: 10000
        })
    }
    isLoading.value = false
}



// getILCoordinates()
setClientOptions()
setCampaignOptions()
setTierOptions()
setCollectionTagOptions()


// loadCompanyLocations()




// import { Loader } from '@googlemaps/js-api-loader';
// import { MarkerClusterer } from "@googlemaps/markerclusterer"; 

// const markerCluster = ref(null)


// const 

// const mapLoader = reactive(new Loader(
//     {
//         apiKey: 'AIzaSyA2xvlXjcnOddpRtuv4LG8v7mSgVYAWrS0',
//         libraries: ['maps', 'marker']

//     }))

// const googleMap = ref(null)

// const numLocations = ref(0)

// const mapOptions = reactive({
//     center: {
//         lat: -28.024, 
//         lng: 140.887
//     },
//     zoom: 3,
//     disableAutoPan: true
//     // disableDefaultUI: false
// })


// onMounted(() => {
//     initMap()
//     // buildLocationsAndInitMap()
// })

// async function buildLocationsAndInitMap() {
//     isLoading.value = true
//     const list = [initMap]
//     for (const fn of list) {
//         await fn()
//     }
//     isLoading.value = false
// }


// async function initMap() {
//     console.log('initMap')
//   mapLoader.load().then((google) => {
//     const map = new google.maps.Map(document.getElementById("map"), {
//         zoom: 3,
//         // maxZoom: 9,
//         minZoom: 3,
//         center: { lat: -28.024, lng: 140.887 },
//         mapId: "99bc138cb59717d1O_MAP_ID",
//     });
//     // const infoWindow = new google.maps.InfoWindow({
//     //     content: "",
//     //     disableAutoPan: true,
//     // });
//     // Create an array of alphabetical characters used to label the markers.
//     // Add some markers to the map.
//     // let locations = buildLocations()
//     let lat = 40.730610
//     let long = -73.935242
//     let locations = []
//     for(let i = 0; i < 50000; i++) {
//         locations.push({lat: lat, lng: long})
//         long -= 0.0001
//         lat -= 0.0002
//     }
//     // lat = 40
//     // long = -122
//     // for(let i = 0; i < 50000; i++) {
//     //     locations.push({lat: lat, lng: long})
//     //     lat -= 0.00015
//     //     long += 0.0003
//     // }
//     // lat = 50.110924
//     // long = 8.682127
//     // for(let i = 0; i < 50000; i++) {
//     //     locations.push({lat: lat, lng: long})
//     //     lat -= 0.00015
//     //     long += 0.0003
//     // }
//     numLocations.value = locations.length
//     const markers = locations.map((position, i) => {
//         // const pinGlyph = new google.maps.marker.PinElement({
//         //     glyph: label,
//         //     glyphColor: "white",
//         // });
//         const marker = new google.maps.marker.AdvancedMarkerElement({
//         position,
//         // content: pinGlyph.element,
//         });

//         // markers can only be keyboard focusable when they have click listeners
//         // open info window when marker is clicked
//         // marker.addListener("gmp-click", () => {
//         //     infoWindow.setContent(position.lat + ", " + position.lng);
//         //     infoWindow.open(map, marker);
//         // });
//         return marker;
//     });

//     // Add a marker clusterer to manage the markers.
//     new MarkerClusterer({ markers, map });
//     }).catch((e) => {
//         console.log(e)
//     })
// }

// async function buildLocations() {
//     console.log('buildLocations')
//     let lat = -30.00
//     let long = 144.00
//     let locs = []
//     for(let i = 0; i < 100000; i++) {
//         locs.push({lat: lat, lng: long})
//         lat += 0.0001
//         long -= 0.001
//     }
//     locations.value = locs
// }

// const locations = [
//   { lat: -31.56391, lng: 147.154312 },
//   { lat: -33.718234, lng: 150.363181 },
//   { lat: -33.727111, lng: 150.371124 },
//   { lat: -33.848588, lng: 151.209834 },
//   { lat: -33.851702, lng: 151.216968 },
//   { lat: -34.671264, lng: 150.863657 },
//   { lat: -35.304724, lng: 148.662905 },
//   { lat: -36.817685, lng: 175.699196 },
//   { lat: -36.828611, lng: 175.790222 },
//   { lat: -37.75, lng: 145.116667 },
//   { lat: -37.759859, lng: 145.128708 },
//   { lat: -37.765015, lng: 145.133858 },
//   { lat: -37.770104, lng: 145.143299 },
//   { lat: -37.7737, lng: 145.145187 },
//   { lat: -37.774785, lng: 145.137978 },
//   { lat: -37.819616, lng: 144.968119 },
//   { lat: -38.330766, lng: 144.695692 },
//   { lat: -39.927193, lng: 175.053218 },
//   { lat: -41.330162, lng: 174.865694 },
//   { lat: -42.734358, lng: 147.439506 },
//   { lat: -42.734358, lng: 147.501315 },
//   { lat: -42.735258, lng: 147.438 },
//   { lat: -43.999792, lng: 170.463352 },
// ];

// initMap();
</script>

<style scoped>
    /* #map {
        height: 500px;
        width: 700px;
        margin: auto;
    } */
</style>